<app-modal-container [displayFooter]="true" xmlns="http://www.w3.org/1999/html" class="modal-container">
  <div class="modal-header-content">
    {{ 'exclude_rules_modal_title' | translate }}
  </div>
  <div class="modal-body-content">
    <p>{{ 'exclude_rules_modal_text' | translate }}</p>

    <div class="row justify-content-between">
      <div class="col-12 col-md-auto d-flex align-items-center mb-3">
        <span class="tool-tag" [innerHTML]="'exclude_rules_modal_tool' | translateHtml: [modalInputData.data.auditTool]"></span>
      </div>
      <div class="col-12 col-md-auto d-flex align-items-center">
        <div class="row">
          <div class="col-12 col-md-auto d-flex align-items-center mb-3 pe-0">
            <label for="entriesPerPage" class="me-2">
              {{ 'label_rows_per_page' | translate }}
            </label>
            <select [(ngModel)]="entriesPerPage" id="entriesPerPage" class="me-4">
              @for (val of entriesAmounts; track $index) {
                <option [ngValue]="val">{{ val }}</option>
              }
            </select>
          </div>
          <div class="col-12 col-md-auto d-flex align-items-center mb-3">
            <span class="me-3 text-black">{{ getPaginationLabel(page, entriesPerPage, tableData.length) }}</span>
            <ngb-pagination
              class="d-flex align-items-center"
              [attr.aria-label]="'aria_label_excluded_rules_table_top_pagination' | translate"
              [(page)]="page"
              [pageSize]="entriesPerPage"
              [collectionSize]="tableData.length"
            >
              <ng-template ngbPaginationPrevious>{{ 'label_previous' | translate }}</ng-template>
              <ng-template ngbPaginationNext>{{ 'label_next' | translate }}</ng-template>
              <ng-template ngbPaginationNumber let-pageNum>
                <span class="visually-hidden">
                  {{ (pageNum !== page ? 'go_to_page' : 'page') | translate }}
                  &nbsp;
                </span>
                {{ pageNum }}
              </ng-template>
            </ngb-pagination>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-12 ignored-rule-table-container">
        <app-ngb-table
          [config]="tableConfig"
          [data]="tableData | slice: (page - 1) * entriesPerPage : page * entriesPerPage"
          (onSort)="onTableSort($event)"
        >
        </app-ngb-table>
      </div>
    </div>

    <div class="row mt-3">
      <div class="col-12 d-flex justify-content-end align-items-center">
        <span class="me-3 text-black">{{ getPaginationLabel(page, entriesPerPage, tableData.length) }}</span>
        <ngb-pagination
          class="d-flex align-items-center"
          [attr.aria-label]="'aria_label_excluded_rules_table_bottom_pagination' | translate"
          [(page)]="page"
          [pageSize]="entriesPerPage"
          [collectionSize]="tableData.length"
        >
          <ng-template ngbPaginationPrevious>{{ 'label_previous' | translate }}</ng-template>
          <ng-template ngbPaginationNext>{{ 'label_next' | translate }}</ng-template>
          <ng-template ngbPaginationNumber let-pageNum>
            <span class="visually-hidden">
              {{ (pageNum !== page ? 'go_to_page' : 'page') | translate }}
              &nbsp;
            </span>
            {{ pageNum }}
          </ng-template>
        </ngb-pagination>
      </div>
    </div>
  </div>

  <div class="d-flex justify-content-end modal-footer-content">
    <button class="btn btn-outline-primary margin-left-md" (click)="close()">
      {{ 'label_close' | translate }}
    </button>
  </div>
</app-modal-container>
